<template>
    <!-- 飘窗效果 -->
    <div
      id="thediv"
      ref="thediv"
      :style="{
        position: 'absolute', zIndex: 111, left: 0, top: 0,height:opts.height,width:opts.width}"
      v-show="thedivShow"
      @mouseover="clearFdAd"
      @mouseout="starFdAd"
      @click="handleByWindow"
    >
      <div
      class="close"
      @click.stop="close">关闭</div>
      <slot>
        <img src="~@/assets/images/bm.png"/>
      </slot>
    </div>
  </template>

  <script>
  var interval;
  export default {
    props:{
      opts:{
        type:Object,
        default:()=>{
          return {
            step: 1,
            delay: 18,// 初始化速度
            width: '280px',
            height: '154px',
          }
        }
      }
    },
    data() {
      return {
        xPos: 0,
        yPos: 0,
        Hoffset: 0,// 盒子的宽高
        Woffset: 0,// 盒子的宽高
        yon: 0,//x y轴的flag
        xon: 0,//x y轴的flag
        pause: true,
        thedivShow: true,
      };
    },
    destroyed(){
      clearInterval(interval)
    },
    mounted() {
      interval = setInterval(this.changePos, this.opts.delay);
    },

    methods: {
      changePos() {
        let width = document.documentElement.clientWidth; //可视文档的宽度
        let height = document.documentElement.clientHeight; //可视文档的高度
        this.Hoffset = this.$refs.thediv.offsetHeight; //获取元素高度
        this.Woffset = this.$refs.thediv.offsetWidth; //获取元素宽度
        // 滚动部分跟随屏幕滚动
        this.$refs.thediv.style.left = (this.xPos/**/
        + document.body.scrollLeft
        + document.documentElement.scrollLeft)
        + "px";
        this.$refs.thediv.style.top = (this.yPos + document.body.scrollTop + document.documentElement.scrollTop) + "px";

        // 滚动部分不随屏幕滚动
        // this.$refs.thediv.style.left =
        // this.xPos + document.body.scrollLeft + "px";
        // this.$refs.thediv.style.top = this.yPos + document.body.scrollTop + "px";

        // y轴位置判断
        if (this.yon) {
          this.yPos = this.yPos + this.opts.step;
        } else {
          this.yPos = this.yPos - this.opts.step;
        }
        if (this.yPos < 0) {
          this.yon = 1;
          this.yPos = 0;
        }
        if (this.yPos >= height - this.Hoffset) {
          this.yon = 0;
          this.yPos = height - this.Hoffset;
        }
        // x轴位置判断
        if (this.xon) {
          this.xPos = this.xPos + this.opts.step;
        } else {
          this.xPos = this.xPos - this.opts.step;
        }
        if (this.xPos < 0) {
          this.xon = 1;
          this.xPos = 0;
        }
        if (this.xPos >= width - this.Woffset) {
          this.xon = 0;
          this.xPos = width - this.Woffset;
        }
      },
      clearFdAd() {
        clearInterval(interval);
      },
      starFdAd() {
        interval = setInterval(this.changePos, this.opts.delay);
      },
      close(){
        clearInterval(interval);
        this.thedivShow = false
      },
      handleByWindow(){
        this.$emit('setByWindow')
      }
    },
  };
  </script>

  <style lang="scss" scoped>
  #thediv {
    z-index: 100;
    position: fixed;
    top: 43px;
    left: 2px;
    height: 72px;
    width: 264px;
    .close{
      cursor: pointer;
      text-align: right;
      position: relative;
      right: 60px;
      font-size: 12px;
      color: #999999;
    }
    img {
      width: 178px;
      height: 103px;
    }
  }
  </style>

